import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import SeventhSection from './SeventhSection';
import './Footer.scss';
import fmlogo from '../../../assets/Images/fmdo-logo-white.png';
import UnifiedButton from '../Button';
import linkdln from '../../../assets/Images/linkedin-icon.svg';
import insta from '../../../assets/Images/instagram logo.svg';
import youtube from '../../../assets/Images/youtube logo.svg';
import { faqDataFeaturePlaylist, faqDataHome, faqDataMusic } from '../../../utilis/FaqData'
import { Link, useLocation, useNavigate } from 'react-router-dom';

const ADVICE_EMAIL = 'fmdigitalofficial@gmail.com';

const OverlapContent = ({ handleGetStarted }) => (
    <Box className="overlap-content">
        <Box className="advice-section">
            <Box>
                <Typography variant="h5" className="advice-title">
                    Need Music Industry Advice?
                </Typography>
                <Typography variant="body1" className="advice-description">
                    Discover the FM Digital Official Artist Academy.
                </Typography>
            </Box>

            <Box>
                <UnifiedButton onClick={handleGetStarted} className="advice-button" textContent={"Request Now"} />
            </Box>
        </Box>
    </Box>
);

const FooterContent = ({ handleNavigation }) => (


    <Box className="footer">
        <Divider className='footer-divider' sx={{ borderColor: 'white', marginBottom: '20px' }} />

        <Box className="footer-logo-container">
            <Box className="footer-brand-block">
                <Box className="footer-logo-fm">
                    <Link to="/">
                        <img src={fmlogo} alt="FM Digital Official" />
                    </Link>
                </Box>
                <Typography className="footer-brand-blurb">
                    Release your music worldwide while keeping control of your music and earnings.
                </Typography>
            </Box>
            <Box className="footer-logo-social">
                <a href="https://www.linkedin.com/company/fmdigitalofficial/?viewAsMember=true" target="_blank" rel="noopener noreferrer" aria-label="FM Digital Official on LinkedIn">
                    <img src={linkdln} alt="LinkedIn Logo" />
                </a>
                <a href="https://www.instagram.com/fmdigitalofficial/" target="_blank" rel="noopener noreferrer" aria-label="FM Digital Official on Instagram">
                    <img src={insta} alt="Instagram Logo" />
                </a>
                <a href="https://www.youtube.com/@FM_Digital_Official" target="_blank" rel="noopener noreferrer" aria-label="FM Digital Official on YouTube">
                    <img src={youtube} alt="YouTube Logo" />
                </a>
            </Box>
        </Box>

        <Box className="footer-content">
            <Box className="footer-links">
                <Box>
                    <Typography variant="h6">Artist & Label Services</Typography>
                    <Typography className='footer-links-text' onClick={() => handleNavigation('/sell-your-music')}  >Sell Your Music</Typography>
                    <Typography onClick={() => handleNavigation('/services/featured-playlists')} className='footer-links-text'>Playlisting</Typography>
                    <Typography className='footer-links-text' onClick={() => handleNavigation('/services/music-marketing')}  >Marketing</Typography>
                    <Typography onClick={() => handleNavigation('/pricing')} className='footer-links-text'>Pricing</Typography>
                </Box>
                <Box>
                    <Typography variant="h6">About</Typography>
                    <Typography onClick={() => handleNavigation('/about', 1)} className='footer-links-text'>Our Story</Typography>
                    <Typography onClick={() => handleNavigation('/about', 2)} className='footer-links-text'>Our Mission</Typography>
                    {/* <Typography className='footer-links-text'>Our Team</Typography> */}
                    <Typography onClick={() => handleNavigation('/about', 3)} className='footer-links-text'>Why Choose Us?</Typography>
                    <Typography onClick={() => handleNavigation('/about', 4)} className='footer-links-text'>Contact</Typography>
                </Box>

                <Box>
                    <Typography variant="h6">Legal</Typography>
                    <Typography onClick={() => handleNavigation('/support/legal-documents', 0)} className='footer-links-text'>Terms of service</Typography>
                    <Typography onClick={() => handleNavigation('/support/legal-documents', 1)} className='footer-links-text'>Distro Agreement</Typography>
                    <Typography onClick={() => handleNavigation('/support/legal-documents', 2)} className='footer-links-text'>Analytics Disclosure</Typography>
                    <Typography onClick={() => handleNavigation('/support/legal-documents', 3)} className='footer-links-text'>Privacy Policy</Typography>
                    <Typography onClick={() => handleNavigation('/support/legal-documents', 4)} className='footer-links-text'>Anti-Fraud Policy</Typography>
                    <Typography onClick={() => handleNavigation('/support/legal-documents', 5)} className='footer-links-text'>Exclusive artist</Typography>
                </Box>
                <Box>
                    <Typography variant="h6">Join us</Typography>
                    <a style={{ textDecoration: 'none' }} href="https://mail.google.com/mail/?view=cm&to=fmdigitalofficial@gmail.com&su=Career%20Inquiry" className='footer-links-text' target="_blank" rel="noopener noreferrer">
                        <Typography>Career</Typography>
                    </a>
                    <a style={{ textDecoration: 'none' }} href="https://mail.google.com/mail/?view=cm&to=fmdigitalofficial@gmail.com&su=Investor%20Opportunities" className='footer-links-text' target="_blank" rel="noopener noreferrer">
                        <Typography>Investor Opportunities</Typography>
                    </a>
                    <a style={{ textDecoration: 'none' }} href="https://mail.google.com/mail/?view=cm&to=fmdigitalofficial@gmail.com&su=Partnership%20Inquiry" className='footer-links-text' target="_blank" rel="noopener noreferrer">
                        <Typography>Partnerships</Typography>
                    </a>
                </Box>
            </Box>
        </Box>

        <Divider sx={{ borderColor: 'white', marginTop: '20px' }} />

        <Typography className="footer-copyright">
            © 2026 FM Digital Official Distribution. All rights reserved.
            <br />
            A subsidiary of Koko Advertising &amp; Marketing.
        </Typography>
    </Box >
);



const MainPage = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleNavigation = (path, sectionId = null) => {

        if (sectionId !== null) {
            // Navigate to the About page with a specific section
            navigate(`${path}?section=${sectionId}`);
        } else {
            // Navigate to the path and scroll to the top of the page
            navigate(path);
            window.scrollTo(0, 0);  // Scroll to top of the page
        }

        window.scrollTo(0, 0);  // Scroll to top of the page
    };



    const handleGetStarted = () => {
        // Opens the visitor's mail client with a request to the artist-support inbox.
        window.location.href = `mailto:${ADVICE_EMAIL}?subject=${encodeURIComponent('Music Industry Advice Request')}`;
    };

    // Determine which FAQ data and title to use based on the route
    let faqData;
    let pageTitle;

    if (location.pathname === '/services/music-marketing') {
        faqData = faqDataMusic;
        pageTitle = "Frequently Asked Questions About Music Marketing";
    } else if (location.pathname === '/services/featured-playlists') {
        faqData = faqDataFeaturePlaylist;
        pageTitle = "Frequently Asked Questions About Distribution";
    } else {
        faqData = faqDataHome; // Default or fallback FAQ data
        pageTitle = "Frequently Asked Questions";
    }

    return (
        <Box className="main-page site-scope">
            {/* Render the SeventhSection with dynamic FAQ data and title */}
            <SeventhSection title={pageTitle} faqs={faqData} />
            <Box className="overlap-wrapper">
                <OverlapContent handleGetStarted={handleGetStarted} />
            </Box>
            <FooterContent handleNavigation={handleNavigation} />
        </Box>
    );
};

export default MainPage;
